(function () {
  function buildHiddenForm(action, form, targetName) {
    var shadowForm = document.createElement('form');
    shadowForm.method = 'post';
    shadowForm.action = action;
    shadowForm.target = targetName;
    shadowForm.style.display = 'none';

    var formData = new FormData(form);
    formData.forEach(function (value, key) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      shadowForm.appendChild(input);
    });

    document.body.appendChild(shadowForm);
    return shadowForm;
  }

  function showSuccessState(form) {
    var successBox = form.parentNode.querySelector('.js-cleverreach-success');

    form.reset();
    form.setAttribute('hidden', 'hidden');
    form.style.display = 'none';

    if (successBox) {
      successBox.hidden = false;
      successBox.style.display = 'block';
    }
  }

  function restoreSubmitButton(submitButton) {
    if (!submitButton) {
      return;
    }

    submitButton.disabled = false;
    submitButton.removeAttribute('aria-disabled');
  }

  function submitViaIframe(action, form, onComplete) {
    var targetName = 'wwd-cleverreach-target-' + Date.now() + '-' + Math.floor(Math.random() * 100000);
    var iframe = document.createElement('iframe');
    iframe.name = targetName;
    iframe.hidden = true;
    iframe.setAttribute('aria-hidden', 'true');
    iframe.style.display = 'none';

    var completed = false;
    var timeoutId = null;

    function finish() {
      if (completed) {
        return;
      }

      completed = true;

      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }

      window.setTimeout(function () {
        iframe.remove();
      }, 1000);

      onComplete();
    }

    iframe.addEventListener('load', function () {
      if (iframe.dataset.submitted === 'true') {
        finish();
      }
    });

    document.body.appendChild(iframe);

    var shadowForm = buildHiddenForm(action, form, targetName);
    shadowForm.submit();
    iframe.dataset.submitted = 'true';

    window.setTimeout(function () {
      shadowForm.remove();
    }, 1000);

    timeoutId = window.setTimeout(finish, 1200);
  }

  function handleNewsletterFormSubmit(event) {
    var form = event.currentTarget;
    var action = form.getAttribute('action');
    var submitButton = form.querySelector('[type="submit"]');

    event.preventDefault();

    if (!action || action === '#') {
      window.console && console.warn('WWD newsletter form has no CleverReach action URL configured.');
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-disabled', 'true');
    }

    submitViaIframe(action, form, function () {
      restoreSubmitButton(submitButton);
      showSuccessState(form);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('.js-cleverreach-newsletter-form');

    if (!forms.length) {
      return;
    }

    forms.forEach(function (form) {
      form.addEventListener('submit', handleNewsletterFormSubmit);
    });
  });
})();
